import { render, staticRenderFns } from "./bindPhoneStep1.vue?vue&type=template&id=3c44d417&scoped=true&"
import script from "./bindPhoneStep1.vue?vue&type=script&lang=js&"
export * from "./bindPhoneStep1.vue?vue&type=script&lang=js&"
import style0 from "./bindPhoneStep1.vue?vue&type=style&index=0&id=3c44d417&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c44d417",
  null
  
)

export default component.exports